import { API_ENDPOINTS } from "@features/creation/config/constants";
import FamilleArticleForm from "@features/creation/famille-articles/components/FamilleArticleForm";
import api from "@lib/api";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { FolderOpen, Pencil } from "lucide-react";

export const Route = createFileRoute("/_app/creation/familleArticles/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.FAMILLE_ARTICLES.EDIT),
  staticData: {
    title: "Modifier la famille",
    icon: Pencil,
    permission: PERMISSIONS.CREATION.FAMILLE_ARTICLES.EDIT,
    module: "creation",
    section: "Creation",
    order: 15,
    showInNav: false,
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: EditFamilleArticlePage,
});

function useFamilleArticleDetail(id) {
  return useQuery({
    queryKey: ["familleArticles", id],
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.FAMILLE_ARTICLES.DETAIL(id));
      return response.data;
    },
    enabled: !!id,
  });
}

function EditFamilleArticlePage() {
  const { id } = useParams({ from: "/_app/creation/familleArticles/$id/edit" });
  const { data: famille, isLoading } = useFamilleArticleDetail(id);

  if (isLoading) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Modifier la famille</h1>
        </div>
        <div className="space-y-4">
          <div className="skeleton h-12 w-full" />
          <div className="skeleton h-24 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier la famille</h1>
        <p className="text-sm text-base-content/60">
          Modifier les informations de la famille {famille?.code}
        </p>
      </div>
      <FamilleArticleForm familleArticle={famille} />
    </div>
  );
}
